import { MenuItem } from '../../../types';
import SearchMenuItem from './SearchMenuItem';
import MyMenuItem from './MyMenuItem';
import HomeMenuItem from './HomeMenuItem';
import AppsMenuItem from './AppsMenuItem';

export const items: MenuItem[] = [
  HomeMenuItem,
  SearchMenuItem,
  AppsMenuItem,
  MyMenuItem,
];
